import React from "react";

export { formatLabel } from "./Text";

const prepend = prefix => str => prefix + str;
const mapProps = (props, which, fn) => {
  const mapped = {};
  which.forEach(prop => {
    if (prop in props) {
      mapped[prop] = fn(props[prop]);
    }
  });
  return Object.assign({}, props, mapped);
};

export const PrependBaseUrl = (base, whichProps, Component) => {
  const prefix = prepend(base);

  return props => {
    const prefixed = mapProps(props, whichProps, prefix);
    return <Component {...prefixed} />;
  };
};

export const AlignDecimals = ({ price }) => {
  const fixed = price.split(".");

  if (fixed.length == 0) {
    return <span>-</span>;
  }

  return (
    <span>
      {fixed[0]}
      <span style={{ minWidth: `4}rem`, textAlign: "left" }}>.{fixed[1]}</span>
    </span>
  );
};

export const DateFormat = ({ date, format }) => {
  var d = new Date(date);
  var yyyy = d.getFullYear();
  var mm = ("0" + (d.getMonth() + 1)).substr(-2);
  var dd = ("0" + d.getDate()).substr(-2);
  return [yyyy, mm, dd].join("-");
};

export const debounce = (func, delay) => {
  let inDebounce;
  return function() {
    const context = this;
    const args = arguments;
    clearTimeout(inDebounce);
    inDebounce = setTimeout(() => func.apply(context, args), delay);
  };
};

export const isScrolledIntoView = el => {
  const rect = el.getBoundingClientRect();
  const elemTop = rect.top;
  const elemBottom = rect.bottom;

  // Partially visible elements return true:
  return elemTop < window.innerHeight && elemBottom >= 0;
};

export const isTradingClose = phase =>
  phase === "CLOS" ||
  phase === "PosC" ||
  phase === "EoPC" ||
  phase === "CLOG" ||
  phase === "CPX";

/**
 * Returns number of deicmal places to display given a value
 * @param {number} number
 * @return {number} - number of decimal places
 */
export const getDecimalPlaces = number => {
  return number <= 0.1 ? 4 : number > 10 ? 2 : 3;
};

/**
 *
 * @param {number} number -
 * @param {number} decimalPlaces -
 * @return {string}
 */
export const formatNumber = (number, decimalPlaces) => {
  if (typeof number != "number" || isNaN(number)) return "-";
  try {
    decimalPlaces =
      decimalPlaces != undefined ? decimalPlaces : getDecimalPlaces(number);
    let whole = number
      .toString()
      .split(".")[0]
      .replace(/(\d)(?=(\d{3})+$)/g, "$1,");
    if (decimalPlaces > 0) {
      return `${whole}.${number.toFixed(decimalPlaces).split(".")[1]}`;
    }
    return whole;
  } catch (e) {
    return "-";
  }
};

export const decodeHTML = str => {
  return new DOMParser().parseFromString(str, "text/html").body.textContent;
};
